import initialState from './initial';

const SharingsReducer = (state = initialState.sharings, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'SHARINGS_LOADED_ALL': {
            return { ...state, ...payload };
        }
        case 'SHARINGS_CHANGED': {
            return { ...state, sharings: [...state.sharings.filter(s => s.sharingId !== payload.sharing.sharingId), payload.sharing] };
        }
        default:
            return state;
    }
};
export default SharingsReducer;
